/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";

function ColumnViewChart({ data }: any) {
  const [state, setState] = React.useState<any>({
    series: [
      { name: "Cancelled", data: [0] },
      {
        name: "Completed",
        data: [0],
      },
      {
        name: "Pending",
        data: [0],
      },

      {
        name: "InRoute",
        data: [0],
      },
      {
        name: "Open",
        data: [0],
      },
      {
        name: "Total",
        data: [0],
      },
    ],
    options: {
      chart: {
        type: "bar",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [""],
      },
      fill: {
        opacity: 1,
      },
    },
  });

  useEffect(() => {
    if (data?.length) {
      setState((prevState: any) => ({
        options: {
          ...prevState.options,
          xaxis: {
            categories: data.map((atm: any) => atm.description),
          },
        },
        series: [
          {
            name: "Cancelled",
            data: data.map((atm: any) => atm.cancelled),
          },
          {
            name: "Completed",
            data: data.map((atm: any) => atm.completed),
          },
          {
            name: "Pending",
            data: data.map((atm: any) => atm.pending),
          },

          {
            name: "InRoute",
            data: data.map((atm: any) => atm.inRoute),
          },
          {
            name: "Open",
            data: data.map((atm: any) => atm.open),
          },
          {
            name: "Total",
            data: data.map((atm: any) => atm.total),
          },
        ],
      }));
    }
  }, [data]);

  return (
    <ReactApexChart
      options={state.options}
      series={state.series}
      type="bar"
      height={340}
    />
  );
}

export default ColumnViewChart;
